import React from 'react';

const CharacterCounter = ({ current, max, style = {} }) => {
  const defaultStyle = {
    fontSize: '12px',
    color: 'var(--color-text-muted)',
    textAlign: 'right',
    marginTop: '2px'
  };

  const combinedStyle = { ...defaultStyle, ...style };

  return (
    <div style={combinedStyle}>
      {current}/{max}
    </div>
  );
};

export default CharacterCounter;
